import React from 'react';
import { CardService, CardProps } from '../card';

export const FtoService = ({ status, service, data, next }: CardProps) => {
	return <CardService status={status} service={service} data={data} next={next} />
};

export default FtoService;
